import { HttpCodes, ValidHttpMethods } from ".";

export interface IMockCallMap {
  method: ValidHttpMethods;
  path: RegExp;
  response: {
    status: HttpCodes;
    body: any;
  };
}
